import { css } from 'styled-components';
import { ITheme } from '../themes';
import { TooltipModeModel } from './tooltip.model';

export const getTooltipModeStyles = (
  theme: ITheme,
  mode: TooltipModeModel
): ReturnType<typeof css> => {
  switch (mode) {
    case 'white':
      return css`
        background-color: ${theme.COLOR.WHITE};
        color: ${theme.COLOR.TEXT_DARK_COLOR};
      `;
    case 'dark':
      return css`
        background-color: #333333;
        color: ${theme.COLOR.WHITE};
      `;
  }
};
